<div class="content-wrapper" style="margin-bottom: 100px">
  <div class="col-md-12 layout-spacing" style="margin-top: 30px">
    <div class="row">
      <div class="col-md-4">
        <div class="card" style="align-items: center">
          <img
            class="card-img-top img-fluid"
            src="assets/img/SensibityLabels.png"
            alt="Card image cap"
          />
          <div class="card-body card-btns" style="width: fit-content">
            <a
              href="https://purview.microsoft.com/informationprotection/purviewmipreports"
              target="_blank"
              class="btn btn-primary btn-rounded"
              style="width: 100%"
              >{{ 'dataClasification.dashboard' | translate }}</a
            >
            <a
              href="https://purview.microsoft.com/informationprotection/informationprotectionlabels/sensitivitylabels"
              target="_blank"
              class="btn btn-primary btn-rounded"
              style="width: fit-content"
              >{{ 'classificationLabels.dataClasify' | translate }}</a
            >
            <a
              href="https://purview.microsoft.com/informationprotection/labelpolicies"
              target="_blank"
              class="btn btn-primary btn-rounded"
              style="width: 100%"
              >{{ 'classificationLabels.appliedPolicies' | translate }}</a
            >
          </div>
        </div>
      </div>
      <div class="col-md-8">
        <div
          class="card text-white bg-pink text-xs-center"
          style="height: 100%"
        >
          <div class="card-body" style="padding: 1.9rem">
            <h3 style="font-size: 1.5rem">
              <strong>{{ 'classificationLabels.title' | translate }}</strong>
            </h3>
            <blockquote class="card-bodyquote">
              <p style="font-size: 1rem" class="mb-3 mt-3">
                {{ 'classificationLabels.section1' | translate }}
              </p>
              <p style="font-size: 1rem" class="mb-3">
                {{ 'classificationLabels.section2' | translate }}
              </p>
              <p style="font-size: 1rem" class="mb-3">
                {{ 'classificationLabels.section3' | translate }}
              </p>
              <p style="font-size: 1rem" class="mb-3">
                {{ 'classificationLabels.section4' | translate }}
              </p>
              <p style="font-size: 1rem" class="mb-3">
                {{ 'classificationLabels.section5' | translate }}
              </p>
              <p style="font-size: 1rem" class="mb-3">
                {{ 'classificationLabels.section6' | translate }}
              </p>
              <p style="font-size: 1rem" class="mb-3">
                {{ 'classificationLabels.section7' | translate }}
              </p>
              <p style="font-size: 1rem" class="mb-3">
                {{ 'classificationLabels.section8' | translate }}
              </p>
              <p style="font-size: 1rem" class="mb-3">
                {{ 'classificationLabels.section9' | translate }}
              </p>
              <p style="font-size: 1rem" class="mb-3">
                {{ 'classificationLabels.section10' | translate }}
              </p>
            </blockquote>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
